import React, { Fragment } from "react";
import { Grid } from "@mui/material";
import TextField from "./TextField";

const CommonTextField = ({
  label,
  placeholder,
  name,
  type,
  value,
  onChange,
  onBlur,
  error,
  required,
  disabled = false,
}) => {
  return (
    <Grid item xs={12} mt={1}>
      <TextField
        fullWidth
        sx={{ marginBottom: "16px" }}
        variant="outlined"
        label={
          <Fragment>
            {!disabled && label}
            {!disabled && required && (
              <span
                style={{
                  color: "red",
                  float: "right",
                  paddingLeft: "5px",
                }}
              >
                *
              </span>
            )}
          </Fragment>
        }
        placeholder={placeholder}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        disabled={disabled}
      />
    </Grid>
  );
};

export default CommonTextField;
